export const newsList =  [
  {
    _id: 0,
    type: '【活動】',
    title: '《新凡人修仙傳》公測開服活動一覽',
    path: './trendsDetail?id=0',
    time: '2022-08-03',
    content: `
    <p>各位道友久等啦：</p>
    <p class="text mb-20">《新凡人修仙傳》將於2022年8月3日9:00（GMT+8）正式開啟！今日仙界重相逢，一聲道友盡滄桑。為了回饋各位道友的辛苦等待，同時也為了能幫助各位道友更好的開啟修仙生活，瓶兒準備了諸多福利活動，靈石、高級招募書、強力夥伴等豪禮相送！</p>
    <p class="text">福利一：十五日登錄送好禮</p>
    <p class="text mb-20">建角後每日登錄即可輕鬆獲得靈石、高級招募書等珍貴道具，登錄滿15天百分百獲得元嬰期南宮婉、元嬰後期寒驪上人和元嬰後期白瑤怡！</p>
    <p class="text">福利二：七日任務</p>
    <p class="text mb-20">每日完成任務可以獲得海量材料和經驗，達到指定分數即可獲得金豆，用於兌換稀有道具，更有元嬰後期品質的暴力輸出英雄血焰古魔！</p>
    <p class="text">福利三：送韓老魔</p>
    <p class="text mb-20">達到相應境界即可獲得海量道具，更能獲得最強元嬰夥伴：散修韓立！</p>
    <p class="text">福利四：免費200連抽</p>
    <p class="text mb-20">每日登錄遊戲即可獲得新手招募書，累計最多共可獲得200連抽。抽滿200抽即可獲得元嬰南宮婉、元嬰散修韓立、元嬰後期寒驪上人！</p>
    <p class="text">福利五：勤修之路</p>
    <p class="text mb-20">完成活動要求輕鬆獲得海量的靈石，助力道友在修仙路上一路飛升！</p>
    <p class="text">福利六：伙伴升星获得海量招募书</p>
    <p class="text mb-20">完成夥伴升星，獲得強大戰力的同時，還能獲得海量招募書，助你獲得更多強力的夥伴，修仙之路更多陪伴！</p>
    <p class="text">福利七：七日排行</p>
    <p class="text mb-20">每天將開啟不同玩法排行榜，榜單獎勵豐厚，還有稀有助你修仙得道！</p>
    <p class="text">福利八：神秘禮包</p>
    <p class="text mb-20">每日遊戲內均會刷新神秘禮包，各種稀有道具等你擁有！</p>
    <p class="text">此外遊戲內還有更多奇遇和精彩玩法，歡迎各位道友進入修仙界體驗，祝各位道友早日飛升！</p>
    `
  },
  {
    _id: 1,
    type: '【活動】',
    title: '《新凡人修仙傳》MyCard儲值活動說明',
    path: './trendsDetail?id=1',
    time: '2022-08-03',
    content: `
    <p>親愛的道友們：</p>
    <p class="mb-20">MyCard儲值活動來襲！單筆儲值指定金額即送超值活動禮包</p>
    <p>【活動期間】</p>
    <p>2022/08/03-2022/08/31</p>
    <p>【活動內容】</p>
    <p class="mb-20">活動期間內，道友們以指定金額點數卡進行儲值，即可獲贈驚喜禮包</p>
    <table width="800" class="mb-20" border="1">
      <thead><tr><th align="center">指定金額點數卡</th><th align="center">活動禮包</th></tr></thead>
      <tbody>
        <tr><td align="center">MyCard500點</td><td align="center">銀兩*500、靈氣*800、道書*10</td></tr>
        <tr><td align="center">MyCard1000點</td><td align="center">銀兩*1000、綠液*20、道書*20</td></tr>
        <tr><td align="center">MyCard3000點</td><td align="center">銀兩*2000、庚精*50、道書*30</td></tr>
        <tr><td align="center">MyCard5000點</td><td align="center">銀兩*3000、庚精*50、離火精*10</td></tr>
        <tr><td align="center">MyCard10000點</td><td align="center">銀兩*3000、庚精*100、離火精*20、修煉卷軸*3</td></tr>
      </tbody>
    </table>
    <p>[注意事項]</p>
    <ul>
      <li>1.本活動獎勵為MyCard通路獎勵，將在儲值後發送至玩家帳號內郵件領取。</li>
      <li>2.若在MyCard儲值時,遇到儲值不成功等問題時請聯絮客服中心。</li>
      <li>3.本次活動的解釋權歸《新凡人修仙傳》運營團隊所有。</li>
      <li>4.玩家需要單次儲值MyCard[指定額度]才可以激活獎勵，大於或者小於指定額度均不會激活獎勵。</li>
      <li>5.此獎勵可以透過多次儲值[指定額度]獲得。</li>
    </ul>
    `
  },
  {
    _id: 2,
    type: '【活動】',
    title: '《MyCard》11 月儲值活動',
    path: './trendsDetail?id=2',
    time: '2022-11-13',
    content: `
    <p class="text-center">
      <img style="width: 500px; margin: 0;" src="${require('@/assets/news/id2-img1.png')}" />
    </p>
    <p class="mb-20">【活動時間】2022/11/14 00:00 ~ 2022/12/09 23:59</p>
    <p class="mb-20">【活動範圍】全服</p>
    <p>【活動內容】</p>
    <p>用 MyCard 儲值享 20% 綁定靈石返利</p>
    <p class="mb-20">道友於活動期間内，使用 MyCard 綫上儲值、會員扣點、點數卡儲值游戲内品項，儲值成功即可在郵件領取 20% 綁定靈石返利。</p>
    <p>【儲值方式】</p>
    <p>活動期間內可以在遊戲內選擇 MyCard 進行儲值即享超值返利，IOS 用戶可以下載官網包進行儲值，也可享受超值返利回饋！</p>
    <p class="mb-20">官網包下載鏈接：<a href="https://xfrxxz.xiaoma.com.tw/download/xfrxxz.apk">https://xfrxxz.xiaoma.com.tw/download/xfrxxz.apk</a></p>
    <p>【注意事項】</p>
    <p>1、 活動採單筆儲值商品品項價格為判斷依據，每一遊戲帳號不限參加次數。</p>
    <p>2、 返利綁定靈石會通過郵件發送，請查看確認，如遇到儲值不成功或未收到返利郵件等問題請聯絮客服中心。</p>
    <p>3、《新凡人修仙傳》運營團隊保留以上活動及獎項內容修改之權利。若因遇不可抗力之因素，活動將有延後舉辦或取消的可能。活動詳情，請以官網最新公告為主。</p>
    `
  },
  {
    _id: 3,
    type: '【活動】',
    title: '卡牌RPG《式神傳說：陰陽對決》事前預約火爆開啟，傳說式神隨心選',
    path: './trendsDetail?id=3',
    time: '2022-12-15',
    content: `
    <p>由魔方數位代理發行的日系妖怪放置卡牌遊戲《式神傳說：陰陽對決》（以下簡稱《式神傳說》）（15）日正式開啟事前預約活動。官方表示，現在完成事前預約，即可領限定「傳說式神自選禮包」，此外參與頁面內式神召集活動，還可提前招募你的專屬式神，更有免費一百連抽，保底可獲得十個傳說級式神，讓你輕鬆開局，同時也有機會獲得 iPhone14 Pro Max、PS5、Switch等豐富實體獎勵。</p>
    <p class="text-center mb-20">
      <img style="width: 500px; margin: 0;" src="${require('@/assets/news/ss.jpg')}" />
    </p>
    <p>重回鐮倉時代，維護京都和平</p>
    <p>鐮倉時代，人類活動範圍與烈度逐漸擴大，不斷侵佔山林、河海等原本被妖怪獨佔的空間，妖怪在平安時代與陰陽師達成脆弱的和平之後，已歷經數十載，邪崇滋生，暗潮翻湧...神秘的面具降臨，傳說獲得面具的大妖將擁有毀天滅地的力量，隱世的陰陽師再度出發，驅鬼降魔，亦或是與大妖結成新的契約...</p>
    <p>在《式神傳說》裡，玩家將化身為陰陽師，開啟封妖驅魔，守護陰陽兩極和平的旅途；遊戲角色和場景都使用pdr材質進行製作；盡量逼近模擬自然界的物理現象，更好的還原畫面的品質和真實感。玩家可以通過收集和培養日本神話/妖怪組成各式陣容進行冒險，遊戲还集多種PVE、PVP玩法和特色養成線，能給玩家帶來豐富的遊戲體驗。</p>
    <p class="text-center mb-20">
    <img style="width: 500px; margin: 0;" src="${require('@/assets/news/ss2.jpg')}" />
    </p>
    <p>好康提前領！iPhone14 Pro Max等你來抽！</p>
    <p>事前預約開啟後，超多豪華的福利活動來襲。預約成功即可獲得「傳說式神自選禮包」，遊戲上線解鎖免費 100 抽，保底十個傳說式神，讓你快速獲得自己心動的式神，當預約人數達成 10 萬、20 萬、30 萬、40 萬、50 萬，還將解鎖契約招募令、式神經驗、勾玉等豐富好康，更有機會抽中 iPhone14 Pro Max、PS5、Switch等豐厚實體獎品！此外，參與頁面內「本命式神」活動，還可解鎖屬於你的限定式神！快來參與吧~</p>
    <p class="text-center mb-20">
    <img style="width: 500px; margin: 0;" src="${require('@/assets/news/ss3.jpg')}" />
    </p>
    <p>更多《式神傳說：陰陽對決》遊戲福利與訊息，敬請關注官方粉絲專頁和後續新聞資訊。</p>
    `
  },
  {
    _id: 4,
    type: '【活動】',
    title: '《式神傳說：陰陽對決》預約突破 20萬，遊戲特色搶先看',
    path: './trendsDetail?id=4',
    time: '2023-01-03',
    content: `
    <p>卡牌RPG《式神傳說：陰陽對決》事前預約活動和雙平台預訂活動現正火熱進行中，官方宣布截止今（20）日，預約人數已成功突破 20 萬。官方表示，即刻參與預約可免費領取「傳說式神 」！還有20萬預約達成加碼豪禮，以及全服共享「百萬連抽 」等豐富福利。此外，官方還提前釋出了遊戲特色內容，供玩家參考。</p>
    <p>遊戲特色搶先看</p>
    <p>【策略搭配，自由選擇】</p>
    <p>山林、河海、部屋、幽都、神、魔六大陣營，豐富的陣營羈絆加成和克制關係，搭配式神們的海量個性技能，策略千變萬化！百鬼式神，任你選擇，策略搭配出你認為的最強陣容！</p>
    <p class="text-center mb-20">
      <img style="width: 500px; margin: 0;" src="${require('@/assets/news/ss.jpg')}" />
    </p>
    <p>【輕鬆放置，豐厚福利】</p>
    <p class="mb-20">放置掛機新玩法！離線掛機，輕鬆升級。任性福利狂送百連抽，每天登陸都有新成長！</p>
    <p>【好友協同，寮中爭霸】</p>
    <p class="mb-20">陰陽寮戰，一觸即發；多人同屏激鬥，守護屬於你的陰陽寮！寮中營地，連協助力，封妖驅魔，維護京都之平和！</p>
    <p>【進階突破，妖怪逆襲】</p>
    <p class="mb-20">合理利用資源進階突破，實現妖怪逆襲！低階大妖，可通過進階，突破為 高階大妖，屬性猛漲，硬撼神魔，這才是真正的“廢卡逆襲！”</p>
    <p>福利好康領不停</p>
    <p class="mb-20">如今《式神傳說：陰陽對決》預約人數已順利突破 20 萬，除了事前登錄和雙平臺預訂活動的豐厚福利外，官方粉絲團再加碼舉辦多重福利贈送活動！玩家只要通過參與官方粉絲專頁每日發佈的貼文互動，即有機會獲得IPhone14 pro Max、PlayStation5、Nintendo Switch等實體大獎！</p>
    <p class="mb-20">更多《式神傳說：陰陽對決》遊戲福利與訊息，敬請關注官方粉絲專頁和後續新聞資訊。</p>
    `
  },
  {
    _id: 5,
    type: '【活動】',
    title: '《式神傳說：陰陽對決》上市日期公開，雙平台預訂火熱進行中',
    path: './trendsDetail?id=5',
    time: '2023-01-03',
    content: `
    <p class="mb-20">由魔方數位代理的全新卡牌手遊《式神傳說：陰陽對決》今（29日）宣佈將於1/6（五）正式上市，目前，雙端事前預訂正在火熱進行中，參與官方事前預約和雙平台預訂活動，不僅可以領取「傳說式神自選禮包」和多重遊戲虛寶獎勵，更有機會將 iPhone14 Pro Max 和 PS5 等實體大獎統統拿到手！</p>
    <p>網路紅人齊助力，邀您pick心動式神</p>
    <p class="mb-20">官方邀請了超過20位網路紅人，以標誌性面具和專屬的動作，分別演繹了遊戲內的百鬼式神； 並發起了pick心動式神的應援活動；玩家通過票選自己心儀的紅人可以參與活動，一起開啟心動冒險吧~參與活動即有機會獲得999勾玉禮包和Mycard點數卡獎勵！不僅如此，據說後續還會有重磅紅人入駐，陪伴玩家一起遊戲！詳細活動可前往官方粉絲頁查看哦~</p>
    <p>事前預約人數突破50萬</p>
    <p class="mb-20">此外，目前官方事前預約已突破50萬，人數達成獎勵已全部解鎖（iPhone14 Pro Max *2、PlayStation5 *3、Nintendo Switch * 3、式神培養大禮包等）；還未參與事前預約活動的玩家，即刻起前往預約，均有機會領取超級大獎！</p>
    <p>更多《式神傳說：陰陽對決》遊戲福利與訊息，敬請關注官方粉絲專頁和後續新聞資訊。</p>
    `
  },
  {
    _id: 6,
    type: '【活動】',
    title: '《式神傳說：陰陽對決》x7-ELEVEN 新春儲值活動',
    path: './trendsDetail?id=6',
    time: '2023-01-06',
    content: `
    <p>《式神傳說：陰陽對決》X 7-ELEVEN迎慶新年，儲值享超值豪禮</p>
    <p>【活動時間】2022/01/06 (10:00)~ 2022/02/06 (23:59) </p>
    <p>【活動內容】於活動期間至全臺7-ELEVEN購買MyCard指定面額3000點&成功儲值進遊戲，享以下專屬豪禮勾玉500、契約召喚卷5、金幣*50萬 </p>
    <p class="mb-20">活動採單筆儲值點數卡面額為判斷依據，每一遊戲帳號限參加一次。</p>
    <p class="mb-20">☆官網儲值連接：<a href=" https://www.xiaoma.com.tw/yys/pay/ "> https://www.xiaoma.com.tw/yys/pay/ </a></p>
    <p>【注意事項】</p>
    <p>1、活動採單筆儲值點數卡面額為判斷依據，每一遊戲帳號限參加一次。</p>
    <p>2、官網儲值成功後，將會通過郵件郵件發送獎勵，請查看確認，如遇到儲值不成功或未收到獎勵郵件等問題請聯絮客服中心。</p>
    <p>3、iOS官方儲值方式和GooglePlay官方儲值方式將不參與本次活動。</p>
    <p>4、活動期間內，請避免臨近24:00時段進行活動，若有爭議將依系統時間為準。</p>
    <p>5、詳細活動說明均以本活動最後公告為準，活動期間系統若發生問題，本公司保留變更或終止本活動時間、內容之權利；活動開始後，所有參與玩家視同同意最後公告之內容；本公司將保留變更獎項內容以及核準兌換與否之權利。</p>
    `
  },
  {
    _id: 7,
    type: '【活動】',
    title: '《式神傳說：陰陽對決》新春新氣象!豪禮送不完!!!',
    path: './trendsDetail?id=7',
    time: '2023-01-06',
    content: `
    <p class="mb-20">專屬於大人們新年MyCard好康活動來啦</p>
    <p>活動一：MyCard儲值享優惠 </p>
    <p>【活動時間】2022/01/06 (10:00)~ 2022/02/06 (23:59) </p>
    <p>【活動內容】</p>
    <p>於活動期間內在官網或遊戲內使用 MyCard 綫上儲值、會員扣點、點數卡儲值勾玉或者禮包，儲值成功即可在郵件領取 10% 勾玉返利。</p>
    <p class="mb-20">活動採單筆儲值商品品項價格為判斷依據，每一遊戲帳號不限參加次數。</p>
    <p>活動二：</p>
    <p>【活動時間】2022/01/06 (10:00)~ 2022/02/05 (23:59) </p>
    <p>【活動內容】</p>
    <p class="mb-20">使用MyCard點數卡，單筆成功直接儲值MyCard1000點（含）以上至遊戲內，可憑MyCard卡號或交易序號至對應活動專區參加抽獎一次，即有機會獲得MyCard 點數50~100000點、 MyCard Coupon30-50元等超值贈品。</p>
    <p>活動三：</p>
    <p>【活動時間】2023/01/11 00:00-2023/01/30 23:59</p>
    <p>【活動內容】</p>
    <p class="mb-20">於活動期間至台灣7-ELEVEN購買MyCard指定面額3000點、5000點、10000點儲值成功，即可至活動領獎專區額外領取MyCard10%回饋。</p>
    <p>☆官網儲值連接：<a href="https://www.xiaoma.com.tw/yys/pay/ "> https://www.xiaoma.com.tw/yys/pay/  </a></p>
    <p class="mb-20">☆抽儲值好禮：<a href=" https://guide.mycard520.com/mycard/135435/"> https://guide.mycard520.com/mycard/135435/</a></p>
    <p>【注意事項】</p>
    <p>1、活動一採單筆儲值商品品項價格為判斷依據，每一遊戲帳號不限參加次數。</p>
    <p>2、官網儲值成功後，將會通過郵件郵件發送獎勵，請查看確認，如遇到儲值不成功或未收到獎勵郵件等問題請聯絮客服中心。</p>
    <p>3、iOS官方儲值方式和GooglePlay官方儲值方式將不參與本次活動。</p>
    <p>4、活動期間內，請避免臨近24:00時段進行活動，若有爭議將依系統時間為準。</p>
    <p>5、詳細活動說明均以本活動最後公告為準，活動期間系統若發生問題，本公司保留變更或終止本活動時間、內容之權利；活動開始後，所有參與玩家視同同意最後公告之內容；本公司將保留變更獎項內容以及核準兌換與否之權利。</p>
    `
  },
  {
    _id: 8,
    type: '【活動】',
    title: '《式神傳說：陰陽對決》玩法攻略第一彈，開荒隊伍推薦',
    path: './trendsDetail?id=8',
    time: '2023-01-06',
    content: `
    <p>各位陰陽師大人們安安，歡迎收看《式神傳說：陰陽對決》玩法攻略第一彈，遊戲剛上市，想必有些大人還未熟悉，今天就讓我來為大人們介紹式神搭配與開荒隊伍！</p>
    <p>首先，先為陰陽師大人們介紹一下遊戲的六大陣營與陣營相剋特點。</p>
    <p class="mb-20">六大陣營分別都有：山林、河海、部屋、幽都、神、魔。</p>
    <p class="mb-20">陣營互相克制：神↔魔、河海→幽都→部屋→山林→河海</p>
    <p>推薦開荒隊伍：</p>
    <p>【開荒先鋒】</p>
    <p>黑川童子、紙妖、川姬、書中仙、鬼將、波浪小僧</p>
    <p>陣容策略：紙妖、川姬群體傷害壓低敵方血量，黑川童子配合擊殺連擊進行收割，波浪小僧可復活隊友，是戰鬥的保障；該陣容前期養成難度低，可協助陰陽師大人們輕鬆度過前期挑戰。</p>
    <p class="mb-20">獲取途徑：黑川童子可通過七日簽到、滿星計劃輕鬆獲取和進階；紙妖可通過首充活動獲取；波浪小僧可通過簽到活動獲取；其餘均可在契約召喚中獲取。</p>
    <p>【進階過渡】</p>
    <p>荒骷髏、惠比壽、海坊主、大天狗、黑川童子、青行燈</p>
    <p>陣容策略：大天狗、荒骷髏群體傷害壓低血線，海坊主可以控制敵方前排，惠比壽會為己方增加buff，黑川童子擊殺連擊進行收割，而青行燈則是隊伍輔助，恢復血量以及復活隊友。</p>
    <p class="mb-20">獲取途徑：荒骷髏可通過骷髏之城活動、限時召喚、七日簽到第七天獲取；青行燈可通過限時召喚獲取；其他均可在契約召喚中獲取；</p>
    <p>【多面增傷】</p>
    <p>般若、惠比壽、輝夜姬、天照、雪女、大天狗</p>
    <p>陣容策略：惠比壽為群體增加buff，天照必殺會因buff而提高攻擊力；天照和大天狗都是群體傷害，開局即可打出爆炸傷害；般若會嘲諷敵方同時也會為自己增加護盾和反擊狀態，是最強坦克；而雪女會群體控制，能為隊伍裡的打手創造很好的輸出環境；輝夜姬則是最強輔助，恢復血量、復活隊友、清除負面狀態、增加護盾樣樣精通！</p>
    <p class="mb-20">獲取途徑：均可通過契約召喚獲得</p>
    <p>強烈建議參考推薦陣容，結合自己抽到的式神來組建自己的推圖陣容；福利黨可優先練姑獲鳥；小氪黨推薦參加首充，骷髏之城活動獲取紙妖和荒骷髏；大佬開局可直接搞神魔式神，推薦最強輸出天照，最強刺客妖刀村正，最強坦克般若！更多搭配可以與其他陰陽師大人交流哦~</p>
    `
  },
  {
    _id: 9,
    type: '【活動】',
    title: '《式神傳說：陰陽對決》玩法攻略第二彈，式神養成小妙招',
    path: './trendsDetail?id=9',
    time: '2023-01-13',
    content: `
    <p>各位陰陽師大人們安安，歡迎收看《式神傳說：陰陽對決》玩法攻略第二彈，想必大人們都已擁有自己的式神陣容，今天就讓我來為大人們介紹式神培養小妙招！希望能幫助大人們突飛猛進！</p>
    <p>首先，讓我們來看一下提升式神戰鬥力都有哪些方式！</p>
    <p>「等級」、「裝備」、「符咒」、「紙靈」、「星級」這五種方式均可直接提高式神戰鬥力！因此針對這五個方式進行培養，將會讓你的式神飛速成長！</p>
    <p class="mb-20">在上述的五種方式中，「星級」對式神的提升是最大的，大人們可以通過式神進階來提高式神的星級，進階後的式神將會有最大化的提升；式神進階需要消耗式神卡牌，可通過契約召喚、滿星計劃、簽到等多個途徑獲得更多的式神卡牌/碎片哦~</p>
    <p class="mb-20">每個星級的式神都會有等級限制「等級」，可通過進階式神來提高等級上限，當式神等級提升時，式神的屬性和戰力也會跟著提升並且達到一定等級還會解鎖式神技能！在遊戲中只要跟敵方有一定的等級差即可隨便碾壓！等級的提升不需要消耗式神卡牌，只需要消耗式神經驗和金幣！可以說是性價比最高的提升方式了！</p>
    <p class="mb-20">「裝備」&「符咒」作為附加屬性，對式神的增長也要看其具體屬性；裝備不僅會增加裝備屬性部分裝備還有陣營加成，對應陣營的式神佩戴後會有額外的加成；而且所有裝備都可以通過強化來提高原本的裝備屬性，式神佩戴了也會相應增加屬性！遊戲中部分式神還擁有專屬武器，式神專屬武器擁有專屬技能，僅有對應式神佩戴時才能觸發，同時，提升專屬武器的等級也會解鎖更多屬性，對比起普通裝備，專屬武器的提升是最高且戰鬥效果最好的！「符咒」則是為式神增加百分比屬性，如生命8%、攻擊8%；自身屬性越高，符咒的加成就越高；同時每個符咒都擁有2個符咒技能，符咒技能種類多，可根據式神自身定位與屬性來搭配符咒技能，符咒技能可通過洗練來替換；</p>
    <p class="mb-20">「紙靈」也屬於附加屬性，但紙靈除了附加屬性之外，還有對應的套裝效果，不同套裝會觸發不同的效果，為式神提供附加屬性外的加成；遊戲中，紙靈可通過妖影秘境、賦靈以及聚靈來獲取</p>
    <p>更多玩法攻略可以在哈拉版與其他大人討論哦~</p>
    `
  },
]